import { jsx as r } from "react/jsx-runtime";
import u from "classnames";
import { useMemo as n } from "react";
import { Card as x } from "./index.es26.js";
import { CompactCard as D } from "./index.es27.js";
import { ContactCard as N } from "./index.es28.js";
import i from "./index.es801.js";
import { useCardGrid as T } from "./index.es802.js";
const p = "card-grid-component", _ = {
  Card: (t) => /* @__PURE__ */ r(x, { ...t }),
  CompactCard: (t) => /* @__PURE__ */ r(D, { ...t }),
  ContactCard: (t) => /* @__PURE__ */ r(N, { ...t })
}, G = ({
  cards: t,
  cardType: d,
  alignGrid: C = "center",
  cardsPerRow: a = "auto",
  gap: c = 16
}) => {
  const { biggestCardHeight: e, biggestCardWidth: o, isZoomed: s } = T({ cards: t, cardType: d }), l = n(
    () => `repeat(${a === "auto" ? "auto-fill" : a}, ${o}px)`,
    [o, a]
  ), f = u(i.root, {
    [i.alignLeft]: C === "left",
    [i.alignRight]: C === "right"
  }), g = n(
    () => ({
      "--width": o && !s ? o + "px" : "100%",
      "--height": e && !s ? e + "px" : "100%"
    }),
    [e, o, s]
  );
  return /* @__PURE__ */ r(
    "div",
    {
      className: f,
      "data-testid": p,
      style: {
        gap: c,
        gridTemplateColumns: l
      },
      children: t.map((m, h) => /* @__PURE__ */ r("div", { id: m.id, className: i.card, style: g, children: _[d]({
        testId: `${p}-card-${h}`,
        ...m
      }) }, m.id))
    }
  );
};
export {
  p as CARD_GRID_DEFAULT_TESTID,
  G as CardsGrid
};
//# sourceMappingURL=index.es30.js.map
